export default "__VITE_ASSET__B7ZNM69D__"